import React, { Component } from 'react'

class Contact extends Component {
    constructor(props) {
        super(props);
        this.state = {
            name: "",
            email: "",
            message: "",
            preferences: "",
            sent: false,
            error: false,
            validation: false
        }
        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    handleInputChange(event) {
        const target = event.target;
        const value = target.value;
        const name = target.name;

        this.setState({
            [name]: value,
            error: false,
            validation: false
        });
    }

    handleSubmit(event) {
        let me = this;
        if (this.state.name === "" || this.state.email === "" || this.state.message === ""|| this.state.preferences === "") {
            this.setState({ validation: true });
        }
        else {
            var request = new XMLHttpRequest();
            request.addEventListener("load", evt => me.setState({ sent: true }));
            request.addEventListener("error", evt => me.setState({ error: true }));
            request.open("POST", "https://234ob50z78.execute-api.ap-southeast-2.amazonaws.com/prod/clairestelle-contact-func");
            request.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
            request.send(JSON.stringify({ "name": this.state.name, "email": this.state.email, "message": this.state.message, "preferences": this.state.preferences }));

        }

        event.preventDefault();
    }
    render() {
        if (this.state.sent) {
            return <div>Thanks for your enqiry, I will respond soon.</div>
        }
        else {
            var message = "";
            if (this.state.error) {
                message = <div>There was a problem submitting your enquiry, please check the form and send again. </div>
            }
            else if (this.state.validation) {
                message = <div>Please check the form and provide a value for Name, Email and Message.</div>
            }
            return (

                <form onSubmit={this.handleSubmit}>
                    {message}
                    <ol>
                        <li>
                            <label htmlFor="name">Name</label>
                            <input type="text" name="name" id="name" onChange={this.handleInputChange} />
                        </li>
                        <li>
                            <label htmlFor="preferences">Do you have a date and shoot time preference?</label>
                            <input type="text" name="preferences" id="preferences" onChange={this.handleInputChange} />
                        </li>
                        <li>
                            <label htmlFor="message">A little bit about yourself</label>
                            <textarea name="message" id="message" rows="6" onChange={this.handleInputChange}></textarea>
                        </li>
                        <li>
                            <label htmlFor="email">Email</label>
                            <input type="text" name="email" id="email" onChange={this.handleInputChange} />
                        </li>                        
                    </ol>
                    <input type="submit" value="Submit" className="button" />
                </form>
            );
        }

    }
}

export default Contact